<template>
  <layout-admin-dashboard-view
    :show-toolbar="false"
    :back-route="{ name: 'admin-landingPage' }">
    <template #title>
      <span>{{ translateTitleCase("lp.admin.lpCreate.title") }}</span>
    </template>

    <template #default>
      <div class="block relative">
        <spinner v-if="!isFormReady" overlay="absolute"></spinner>
        <custom-crud-create
          ref="crudCreate"
          v-bind="createConfiguration"
          @item:updated="handleItemUpdated"></custom-crud-create>
      </div>
    </template>
  </layout-admin-dashboard-view>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import useLandingPage from "@/client/applications/meitavlp/extensions/composition/useLandingPage";
import CustomCrudCreate from "@/client/components/crud/customV1/Create.vue";

import { computed } from "vue";
export default {
  components: { CustomCrudCreate },
  layout: "adminDashboard",
  middleware: {
    requireSuperAdmin: {},
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    let { landingPageForm } = useLandingPage(props);

    return {
      asyncOps,
      asyncOpsReady,
      asyncStatus,
      landingPageForm,
    };
  },
  meta: "lp.admin.lpCreate.pageTitle",
  data: function () {
    return {
      isMounted: false,
      isFormReady: computed(() => this.landingPageForm.isReady),
      createConfiguration: {
        subject: "landingPage",
        submitUrl: "landingPage/",
        cancelRedirect: { name: "admin-landingPage" },
        successRedirect: { name: "admin-landingPage" },
        initialItemData: {
          sectionTypeList: [],
        },
        formConfig: computed(() => this.landingPageForm.config),
      },
      asyncData: {},
    };
  },
  computed: {},
  created() {
    this.landingPageForm.adjustTypes([], true);
  },
  mounted() {
    this.isMounted = true;
    this.setDefaultFormValues();
  },
  methods: {
    handleItemUpdated({ itemData }) {
      let targetTypes = Array.isArray(itemData.sectionTypeList)
        ? itemData.sectionTypeList
        : [];

      this.landingPageForm.adjustTypes(targetTypes);
      this.setDefaultFormValues();

      let sectionTypeKeys = itemData.sectionTypeList
        .filter((item) => typeof item.type === "string")
        .map((item) => item.type);

      let index = 0;
      sectionTypeKeys.forEach((type) => {
        if (!itemData[type]) {
          return true;
        }

        if (itemData[type].sectionOrder !== index) {
          itemData[type].sectionOrder = index;
        }
        index = index + 1;
      });
    },
    setDefaultFormValues() {
      if (this.isMounted) {
        this.$refs["crudCreate"].setDefaultFormValues();
      }
    },

    // TODO: section preview (images/ showcase),
    // todo: before send hook - remove section data that does not match section list
  },
};
</script>

<style scoped lang="scss"></style>
